import Accordion from 'accordion-js';

new Accordion('.faq-acc-container');
